module.exports = __webpack_public_path__ + "img/ch07_04_站台等车.14a21a92.jpg";